import { connect } from 'react-redux';

import { selectMetricDataForContentItem } from '../../../metrics/selectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { MetricCard, MetricCardOwnProps, MetricCardStateProps } from './MetricCard';


const mapStateToProps: MapStateToProps<MetricCardStateProps> = (state: AppState, ownProps: MetricCardOwnProps) => {
  return {
    metricData: selectMetricDataForContentItem(state, ownProps.content),
  };
};

export const ConnectedMetricCard: React.ComponentClass<MetricCardOwnProps> = connect(mapStateToProps, undefined)(MetricCard);
